import styled from '@emotion/styled'

import { palette, spacing, Text } from 'main/ui'

export const Container = styled.div`
  display: flex;
  flex-direction: row;

  > :not(:last-child) {
    margin-right: ${spacing.minorScale(1)}px;
  }
`

export const LabelContainer = styled.a`
  align-items: center;
  background-color: rgba(0, 0, 0, 0.4);
  border-radius: 3px;
  display: flex;
  flex-direction: row;
  padding: 0 ${spacing.majorScale(1)}px;
  text-decoration: none;
`

export const Label = styled(Text)`
  color: ${palette.white};
`
